import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import SelectDate from '../inputs/SelectDate.jsx';
import SelectDateSimple from '../inputs/SelectDateSimple.jsx';
import Text from '../inputs/Text.jsx';
import RadioInput from '../inputs/RadioInput.jsx';
import RangeInput from '../inputs/RangeInput.jsx';
import SelectManagers from '../inputs/SelectManagers.jsx';
import GcDateRangePicker from "../../common/inputs/GcDateRangePicker.jsx";
import Select from '../inputs/Select.jsx';
import CompareYear from "../../common/inputs/CompareYear.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import SelectAccommodations from '../inputs/SelectAccommodations.jsx';
import SelectStatus from '../inputs/SelectStatus';

const Wrapper = styled.div`
  .card {
    background-color: #D8DFE0;
  }
`

export default function FiltersCard(props) {
  const {
    parentFunction,
    open,
    inputs,
    minimize = false,
    col = 3
  } = props;

  const [showAll, setShowAll] = useState(false);

  const renderInput = (input) => {
    switch (input.type) {
      case 'select':
        return (
          <Select 
            parentFunction={parentFunction} 
            slug={input.slug} 
            label={input.label} 
            items={input.data}
            selectedItems={input.selectedItems} 
            autoTrad={input.autoTrad}
            multiple={false}
            clearable={input.clearable}
          />
        )
      case 'multipleSelect':
        return (
          <Select 
            parentFunction={parentFunction} 
            slug={input.slug} 
            label={input.label} 
            items={input.data}
            selectedItems={input.selectedItems} 
            autoTrad={input.autoTrad}
            multiple={true}
            checkbox={input.checkbox || false}
          />
        )
      case 'selectManagers':
        return (
          <SelectManagers
            parentFunction={parentFunction}
            slug={input.slug}
            label={input.label}
            selectedItems={input.selectedItems}
          />
        )
      case 'selectAccommodations':
        return (
          <SelectAccommodations
            parentFunction={parentFunction}
            selectedItems={input.selectedItems}
          />
        )
      case 'selectDate':
        return (
          <SelectDate
            parentFunction={parentFunction}
            slug={input.slug}
            label={input.label}
            items1={input.data1}
            selectedItems1={input.selectedItems1}
            items2={input.data2}
            selectedItems2={input.selectedItems2}
            autoTrad={input.autoTrad}
            custom={input.custom}
            periodChoice={input.periodChoice}
            selectedDates={input.selectedDates}
            disabled={input.disabled}
          />
        )
      case 'selectDateSimple':
        return (
          <SelectDateSimple
            parentFunction={parentFunction}
            slug={input.slug}
            label={input.label}
            items={input.data}
            selectedItems={input.selectedItems}
            autoTrad={input.autoTrad}
            custom={input.custom}
          />
        )
      case 'text':
        return (
          <Text
            onChange={parentFunction}
            slug={input.slug}
            label={input.label}
            autoTrad={input.autoTrad}
          />
        )
      case 'radio':
        return (
          <RadioInput
            parentFunction={parentFunction}
            slug={input.slug}
            label={input.label}
            autoTrad={input.autoTrad}
            inputClasses={input.inputClasses}
            options={input.options}
            selected={input.selected}
          />
        )
      case 'range':
        return (
          <RangeInput
            parentFunction={parentFunction}
            slug={input.slug}
            label={input.label}
            min={input.min}
            max={input.max}
            selectedValue={input.selectedValue}
            disabled={input.disabled}
          />
        )
      case 'daterangepicker':
        return (
          <GcDateRangePicker
            parentFunction={parentFunction}
            slug={input.slug}
            label={input.label}
            selectedDates={input.selectedDates}
            maxDate={input.maxDate}
            minDate={input.minDate}
            disabled={input.disabled}
          />
        )
        case 'compareYear':
        return (
          <CompareYear
            parentFunction={parentFunction}
            slug={input.slug}
            labelYear1={input.labelYear1}
            labelYear2={input.labelYear2}
            labelType={input.labelType}
            selectedYear1={input.selectedYear1}
            selectedYear2={input.selectedYear2}
            typeItems={input.typeItems}
            selectedTypeItems={input.selectedTypeItems}
            maxDate1={input.maxDate1}
            maxDate2={input.maxDate2}
            autoTrad={input.autoTrad}
            disableCompareType={input.disableCompareType}
          />
        )
        case 'StatusRequestHotelAccommodation':
        return (
          <SelectStatus
            multiple={true}
            onChange={parentFunction}
            selected={input.selectedItems}
            route={input.route}
            filter_id={input.slug} 
            label={input.label} 
          />
        )
    }
  }

  let visiblefilterNb = 0;
  let colClass = 'col-12 col-md-6 col-xl-4';
  switch(col) {
    case 2:
      colClass = 'col-12 col-md-6 col-xl-6'
      break;
    case 4:
      colClass = 'col-12 col-md-6 col-xl-3'
      break;
  }

  return (
    <Wrapper>
      <Collapse in={open}>
        <div className={"card card-body border-none text-gc-dark-blue m-0 mb-3 pb-0 pb-1 " + (props.className ?? "")}>
          <div className="row">
          {inputs.map((input, i) => {
            if (input.hide != true) {
              visiblefilterNb++;
              if (!minimize || visiblefilterNb <= 3) {
                return (
                  <div key={i} className={input.divClass ?? colClass}>
                    <div className="form-group">
                      {renderInput(input, parentFunction)}
                    </div>
                  </div>
                )
              } else {
                return (
                  <Collapse in={showAll} key={i} className={input.divClass ?? colClass}>
                    <div className="form-group">
                      {renderInput(input, parentFunction)}
                    </div>
                  </Collapse>
                )
              }
            }
          })}
          {minimize && inputs.length > 3 && (
            <div className="col-12">
              <button
                className="btn btn-link"
                onClick={() => setShowAll(!showAll)}
              >
                <span className="d-md-inline-block small">
                  {showAll ? 'moins_de_filtres'.trad() : 'plus_de_filtres'.trad()}
                </span>
                <span className="ml-2">
                  {showAll ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                </span>
              </button>
            </div>
          )}
          </div>
        </div>
      </Collapse>
    </Wrapper>
  );
}